import { createDateInNorwegianTime as createNorwegianDate } from '../../../services/new-utils.ts';

export const MAY_2024_COMPETITION_END_DATE = createNorwegianDate(2024, 6, 1, 0);
